import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { ReactSVG } from "react-svg";
import styles from "./MediaInfo.module.scss";
import ModalRoot from "../_primitives/Modal/ModalRoot/ModalRoot";
import ModalTrigger from "../_primitives/Modal/ModalTrigger/ModalTrigger";
import ModalContent from "../_primitives/Modal/ModalContent/ModalContent";
import { ModalClose } from "../_primitives/Modal/ModalClose/ModalClose";
import { FileType, ImageType } from "@/types/baseTypes";
import ModalPortal from "../_primitives/Modal/ModalPortal/ModalPortal";
import { ReactElement, useRef } from "react";
import { generateCopyrightJSX } from "../Global/Copyright/Copyright";
import ModalOverlay from "../_primitives/Modal/ModalOverlay/ModalOverlay";
import MediaInfoModalContent from "./MediaInfoModalContent";

interface MediaInfoProps {
  media: React.ReactNode;
  image_fullhd?: ImageType | false;
  image_desktop?: ImageType | false;
  image_tablet?: ImageType | false;
  image_mobile?: ImageType | false;
  video?: FileType;
  trigger?: ReactElement;
  modalInsideBody?: boolean;
}

const MediaInfo = ({
  media,
  video,
  image_desktop,
  image_fullhd,
  image_tablet,
  image_mobile,
  trigger,
  modalInsideBody = false, //images want their modal to be inside the section where they are so background color can be passed, for videos its fine to be in body
}: MediaInfoProps) => {
  const { getIcon, getLabel } = useGlobalContext();

  const hasMobileDescription = !!(image_mobile && image_mobile?.description);
  const hasTabletDescription = !!(image_tablet && image_tablet?.description);
  const hasDesktopDescription = !!(image_desktop && image_desktop?.description);
  const hasFullhdDescription = !!(image_fullhd && image_fullhd?.description);
  const hasVideoDescription = !!(video && video?.description);

  const portalContainer = useRef<HTMLDivElement>(null);

  const copyrightJSX = generateCopyrightJSX(
    image_desktop || undefined,
    getLabel,
  );

  if (
    !hasMobileDescription &&
    !hasTabletDescription &&
    !hasDesktopDescription &&
    !hasFullhdDescription &&
    !hasVideoDescription &&
    copyrightJSX.length === 0
  ) {
    return;
  }
  return (
    <>
      <ModalRoot>
        <ModalTrigger>
          {trigger ?? (
            <button
              className={`${styles["media-info-button"]} button-reset`}
              aria-label={getLabel("aria_label_media_info_button")}
            >
              <ReactSVG
                src={getIcon("info")}
                wrapper={"svg"}
                width={16}
                height={16}
                beforeInjection={(svg) => {
                  svg.setAttribute("alt", `info Icon`);
                  svg.setAttribute("aria-label", `info Icon`);
                }}
              />
            </button>
          )}
        </ModalTrigger>
        <ModalPortal
          portalRef={modalInsideBody ? undefined : portalContainer.current}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalClose />
            <MediaInfoModalContent
              copyrightJSX={copyrightJSX}
              media={media}
              image_desktop={image_desktop || undefined}
              image_fullhd={image_fullhd || undefined}
              image_tablet={image_tablet || undefined}
              image_mobile={image_mobile || undefined}
              hasVideoDescription={hasVideoDescription}
              hasMobileDescription={hasMobileDescription}
              hasTabletDescription={hasTabletDescription}
              hasDesktopDescription={hasDesktopDescription}
              hasFullhdDescription={hasFullhdDescription}
              video={video}
            />
          </ModalContent>
        </ModalPortal>
      </ModalRoot>
    </>
  );
};

export default MediaInfo;
